import { InjectionToken } from '@angular/core';

import { FilteringFeatureNames } from '@ciphr/shared/collections-filtering/models';

export const COLLECTIONS_FILTERING_EFFECTS_IDENTIFIER = new InjectionToken<FilteringFeatureNames>(
  'Collections Filtering Effects Identifier',
);
